var document = window.document;
// shorthand
export var $ = function (id) { return document.getElementById(id); };
export var $1 = function (selectors) { return document.querySelector(selectors); };
export var $$ = function (selectors) { return document.querySelectorAll(selectors); };
export var $tap = function (obj) {
    var cbs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        cbs[_i - 1] = arguments[_i];
    }
    return (cbs.forEach(function (cb) { return cb(obj); }), obj);
};
export var $n = function (num, options) {
    return new Intl.NumberFormat('en-US', options).format(num);
};
export function on(events, selectors, listener) {
    var handler = function (ev) {
        var _a;
        var target = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.closest(selectors);
        if (target)
            handleEvent(ev, target, listener);
    };
    for (var _i = 0, _a = Array.isArray(events) ? events : [events]; _i < _a.length; _i++) {
        var event_1 = _a[_i];
        document.body.addEventListener(event_1, handler);
    }
}
function handleEvent(ev, currentTarget, listener) {
    Object.defineProperty(ev, 'currentTarget', { get: function () { return currentTarget; }, configurable: true });
    listener.call(currentTarget, ev);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete ev.currentTarget;
}
// CSRF
export function csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}
export function xsrfToken() {
    var match = /(?:^|;)\s*XSRF-TOKEN=([^;\s]+)/.exec(document.cookie);
    return decodeURIComponent(match[1]);
}
export function $e(tagName, props) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var element = document.createElement(tagName);
    Object.assign(element, props);
    element.append.apply(element, children);
    return element;
}
export function $icon(className, props) {
    return $e('span', props, $e('i', { className: className }));
}
export function $hidden(name, value) {
    return $e('input', { type: 'hidden', name: name, value: value });
}
export function $hiddens(name, values) {
    return Object.entries(values).map(function (_a) {
        var key = _a[0], value = _a[1];
        return $hidden("".concat(name, "[").concat(key, "]"), "".concat(value));
    });
}
export function inputs(elem) {
    return elem.form.querySelectorAll("input[name=\"".concat(elem.name, "\"]"));
}
